import { Box, Container, Grid2, Stack, StackProps, Typography, useTheme } from "@mui/material"
import { Variant } from "@mui/material/styles/createTypography"
import { graphql } from "gatsby"
import React from "react"
import Marquee from "react-fast-marquee"
import { ContentfulAssetImage, Kicker } from "./ui"

export type LogoListProps = Queries.HomepageLogoListContentFragment & {
  headerComponent?: Variant
  RootStackProps?: StackProps
  aboveFold?: boolean
  imgStyle?: React.CSSProperties
}

const maxLogoWidth = "250px"

const defaultImgStyle = { maxWidth: maxLogoWidth, filter: "grayscale(100%)", opacity: 0.5, maxHeight: "60px" }

type LogoListGridProps = {
  logos: Queries.HomepageLogoListContentFragment['logos'],
  aboveFold: boolean
  imgStyle?: React.CSSProperties
}

const LogoListGrid = ({ logos, aboveFold, imgStyle }: LogoListGridProps) => {
  return (
    <Container>
      <Grid2 container spacing={{ xs: 4 }} alignItems="center" justifyContent={"center"}>
        {
          logos
            .map((logo) => (
              <Grid2
                size={{ xs: 12, sm: 3, md: 4, lg: 3 }}
                display="flex" justifyContent="center" alignItems="center"
                key={logo.id}
              >
                <ContentfulAssetImage
                  skipGatsbyImage
                  aboveFold={aboveFold}
                  asset={logo.image}
                  imgStyle={{ ...defaultImgStyle, ...imgStyle }}
                  alt={logo.alt}
                />
              </Grid2>
            ))
        }
      </Grid2>
    </Container>
  )
}

export default function LogoList(props: LogoListProps) {
  const theme = useTheme()
  return (
    <Box sx={{ width: '100%' }}>
      <Stack direction="column" spacing={3} sx={{ width: '100%' }}
        justifyContent="center"
        alignItems="center" {...props.RootStackProps}>
        <Stack
          rowGap={3}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >

          {props.kicker ? (
            <div>
              <Kicker label={props.kicker} icon={props.kickerIcon} />
            </div>
          ) : (
            <></>
          )}

          {props.title && (
            <Typography
              variant={props.headerComponent ? props.headerComponent : "h2"}
              sx={{ textAlign: "center", color: theme.palette.text.primary }}
            >
              {props.title}
            </Typography>
          )}

          {props.text && (
            <Typography
              variant={'body1'}
              sx={{ textAlign: "center", color: theme.palette.text.primary }}
            >
              {props.text}
            </Typography>
          )}
        </Stack>

        {props.logos.length > 5 ? (
          <>
            {/* <Box sx={{ display: { xs: 'initial', sm: 'initial', md: 'initial', lg: 'none' }, width: '100%' }}>
              <LogoListGrid logos={props.logos} aboveFold={props.aboveFold} imgStyle={props.imgStyle} />
            </Box> */}

            {/* <Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'initial' }, width: '100%' }}> */}
            <Box sx={{ width: '100%' }}>
              <Marquee
                pauseOnHover={false}
                gradient
                loop={0}
                speed={50}
                gradientWidth={100}
              >
                {props.logos
                  .map((logo) => (
                    <Box
                      key={logo.id}
                      sx={{
                        mr: { xs: "25px", sm: "25px", md: "40px" },
                      }}
                    >
                      <ContentfulAssetImage
                        skipGatsbyImage
                        aboveFold={props.aboveFold}
                        imgStyle={{ ...defaultImgStyle, ...props.imgStyle }}
                        asset={logo.image}
                        alt={logo.alt}
                        svgStyle={{ height: '60px' }}
                      />
                    </Box>
                  ))}
              </Marquee>
            </Box>
          </>
        )
          : (
            <LogoListGrid logos={props.logos} aboveFold={props.aboveFold} imgStyle={props.imgStyle} />
          )}
      </Stack>
    </Box>
  )
}

export const query = graphql`
  fragment HomepageLogoListContent on ContentfulHomepageLogoList {
    id
    title
    kicker    
    kickerIcon {      
      url
      id
      title      
      __typename
      contentful_id
      file {
        contentType
      }      
      localFile {
        childImageSharp { 
          gatsbyImageData(height: 20, width: 20)
        }
      }
    }
    text
    logos {
      id
      alt
      image {
        ...on ContentfulAsset {
          url
          id
          title      
          __typename
          contentful_id
          file {
            contentType
          }      
          localFile {
            childImageSharp { 
              gatsbyImageData (
                height: 60
                # width: 150
                # aspectRatio: 6.8
                quality: 100
                layout: CONSTRAINED          
              )
            }
          }
      }        
    }
  }
  }
`
